import React, { useEffect } from 'react';

export default function Disclaimer() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-[2rem] p-8 md:p-12 shadow-sm border border-slate-100">
          <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-8">Medical Disclaimer</h1>
          
          <div className="space-y-6 text-slate-600 leading-relaxed">
            <p>
              The content provided on the RenewRX website, including text, graphics, images, and other materials, is for informational purposes only. It is not intended to be a substitute for professional medical advice, diagnosis, or treatment.
            </p>
            
            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">No Doctor-Patient Relationship</h2>
            <p>
              Use of this website does not create a doctor-patient relationship. A doctor-patient relationship is only established after a licensed medical professional has reviewed your health information and formally accepted you as a patient through our secure telehealth platform.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Consult Your Physician</h2>
            <p>
              Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition. Never disregard professional medical advice or delay in seeking it because of something you have read on this website.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Prescription Policy</h2>
            <p>
              All prescription medications are prescribed by licensed medical professionals based on their independent clinical judgment. There is no guarantee that a prescription will be written. Medications are fulfilled by licensed pharmacies, such as Leg Up Recovery, and shipped directly to patients.
            </p>
            
            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Emergency Situations</h2>
            <p>
              If you think you may have a medical emergency, call your doctor or 911 immediately. RenewRX does not provide emergency medical services.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}